module.exports = __webpack_public_path__ + "media/images/yappy-logo-14ab65a9a9a16d13d6c2ef85414ebe657dc004663348e24246b2039a8cdeebd1.png";